import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * Conditional classes, with later Tailwind utilities winning over earlier ones.
 *
 * tailwind-merge has to be told about the custom scales. Without this it reads
 * `text-body` as a colour rather than a size and drops the `text-white` beside
 * it, which silently paints white-on-ink buttons in ink-on-ink.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            'hero',
            'page',
            'card',
            'row',
            'row-sub',
            'body',
            'meta',
            'meta-sm',
            'label',
            'chip',
          ],
        },
      ],
      'font-weight': [
        { font: ['book', 'medium-plus'] },
      ],
      rounded: [{ rounded: ['card', 'panel', 'control', 'pill'] }],
      shadow: [{ shadow: ['card', 'menu'] }],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
